import {Auth} from 'aws-amplify';

export const awsApiName = process.env.REACT_APP_AWS_API_NAME || '';

export const AUTH_CONFIG = {
  region: process.env.REACT_APP_AWS_REGION,
  userPoolId: process.env.REACT_APP_USER_POOL_ID,
  userPoolWebClientId: process.env.REACT_APP_USER_POOL_WEB_CLIENT_ID,
  signUpVerificationMethod: 'link',
  oauth: {
    domain: process.env.REACT_APP_OAUTH_DOMAIN,
    scope: ['email', 'profile', 'openid'],
    redirectSignIn: process.env.REACT_APP_OAUTH_REDIRECT_SIGN_IN,
    redirectSignOut: process.env.REACT_APP_OAUTH_REDIRECT_SIGN_OUT,
    responseType: 'code'
  }
};

export const API_CONFIG = {
  endpoints: [
    {
      name: process.env.REACT_APP_AWS_API_NAME,
      endpoint: process.env.REACT_APP_AWS_API_ENDPOINT,
      custom_header: async () => {
        try {
          const session = await Auth.currentSession();
          return {Authorization: `Bearer ${session.getIdToken().getJwtToken()}`};
        } catch (error) {
          return {};
        }
      }
    }
  ]
}